import axios from "axios";
import GLOBAL from "./Util";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';

export function axiosPost(url, data, callback, callbackerror) {
    GLOBAL.isLoading=true;
    axios.post(GLOBAL.url + url, data )
    .then(response=>{
        GLOBAL.isLoading=false;
        callback(response);
    })
    .catch(error => {
        GLOBAL.isLoading=false;
        callbackerror(error);
    });
}

export function axiosGetWithHeader(url, callback, callbackerror) {
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': "Bearer "+ getz(localStorage.getItem("token"))  
    }
    GLOBAL.isLoading=true;
    axios.get(GLOBAL.url + url, {headers: headers} )
    .then(response=>{
        GLOBAL.isLoading=false;
        callback(response);
    })
    .catch(err => {
        GLOBAL.isLoading=false;
        callbackerror(err);
    });
}


export function axiosPostWithHeader(url, data, callback, callbackerror) {
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': "Bearer "+ getz(localStorage.getItem("token"))  
    }
    GLOBAL.isLoading=true;
    axios.post(GLOBAL.url + url, data, {headers: headers} )
    .then(response=>{
        GLOBAL.isLoading=false;
        callback(response);
    })
    .catch(err => {
        GLOBAL.isLoading=false;
        callbackerror(err);
    });
}

export function axiosPutWithHeader(url, data, callback, callbackerror) {
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': "Bearer "+ getz(localStorage.getItem("token") ) 
    }
    GLOBAL.isLoading=true;
    axios.put(GLOBAL.url + url, data, {headers: headers} )
    .then(response=>{
        GLOBAL.isLoading=false;
        callback(response);
    })
    .catch(err => {
        GLOBAL.isLoading=false;
        callbackerror(err);
    });
}

export function axiosDeleteWithHeader(url, callback, callbackerror) {
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': "Bearer "+ getz(localStorage.getItem("token") ) 
    }
    GLOBAL.isLoading=true;
    axios.delete(GLOBAL.url + url, {headers: headers} )
    .then(response=>{
        GLOBAL.isLoading=false;
        callback(response);
    })
    .catch(err => {
        GLOBAL.isLoading=false;
        callbackerror(err);
    });
}

function getz(s){
    if(s===null) return null;
    var str="";
    str+=s.substring(0,10);
    for(var i=10;i<(s.length-10);i=i+6) {
        if((i+5)<(s.length-10))
            str+=s.substring(i,i+5);
        else
            str+=s.substring(i,s.length-10);
    }
    str+=s.substring(s.length-10);
    return str;
}

export function gets(s){
    if(s===null) return null;
    var str="";
    str+=s.substring(0,2);
    for(var i=2;i<(s.length-2);i=i+4) {
        if((i+3)<(s.length-2))
            str+=s.substring(i,i+3);
        else
            str+=s.substring(i,s.length-2);
    }
    str+=s.substring(s.length-2);
    return str;
}
export function axiosResponseHandler(response, reference, handleReset, message) {
    if(response.data.code!=='200') {
        console.log('Error : '+response.data.code+' '+response.data.message);
        reference.current.focus();
        GLOBAL.isLoading=false;
        return response.data.message;
    } else {
        handleReset();
        GLOBAL.isLoading=false;
        return "<font color=\"blue\">"+message+"</font>";
    }   
}


export function axiosErrorHandler(reference, error) {
    console.log('LOG: : '+error.message+" : "+error.response+' : '+error.request);
    reference.current.focus();
    var message="";
    if(error.message==="Network Error") {
        message = "Network Error - Please check internet connection";
    } else {
        message = "Unknown Error - Please try later or report the issue";
    }
    GLOBAL.isLoading=false;
    return message;
}

export function ShowAlertError({errorAlert,setErrorAlert}) {
    const navigate = useNavigate();

    const handleHome=() =>{
        setErrorAlert(null);
        setTimeout(() => {
          navigate('/home.html', { replace: true });
        }, 100);
    }

    const handleLogout=() =>{
        setErrorAlert(null);
        localStorage.removeItem("token");
        setTimeout(() => {
            navigate('/', { replace: true });
        }, 100);
    }
        
    return (
        <>
            {errorAlert!=="Request failed with status code 403"?<></>:
                <Modal centered backdrop="static" show="true" onHide={handleLogout}>
                <Modal.Header closeButton>
                    <Modal.Title>Login Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>Login Expired. Please Login again</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleLogout}>Login</Button>
                </Modal.Footer>
                </Modal>
            }
            {errorAlert!=="Network Error"?<></>:
                <Modal centered backdrop="static" show="true" onHide={()=>handleHome()}>
                <Modal.Header closeButton>
                    <Modal.Title>Network Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>Network Error - Please check internet connection</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={()=>handleHome()}>Ok</Button>
                </Modal.Footer>
                </Modal>
            }
        </>
    )
}

export function ShowGenericAlertError({errorAlert,setErrorAlert,msgtitle,msgbody,msgbutton,callback}) {
    const navigate = useNavigate();

    const handleHome=() =>{
        setErrorAlert(null);
        setTimeout(() => {
          navigate('/home.html', { replace: true });
        }, 100);
    }

    const handleLogout=() =>{
        setErrorAlert(null);
        localStorage.removeItem("token");
        setTimeout(() => {
            navigate('/', { replace: true });
        }, 100);
    }
        
    return (
        <>
            {errorAlert!=="Request failed with status code 403"?<></>:
                <Modal centered backdrop="static" show="true" onHide={handleLogout}>
                <Modal.Header closeButton>
                    <Modal.Title>Login Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>Login Expired. Please Login again</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleLogout}>Login</Button>
                </Modal.Footer>
                </Modal>
            }
            {errorAlert!=="Network Error"?<></>:
                <Modal centered backdrop="static" show="true" onHide={()=>handleHome()}>
                <Modal.Header closeButton>
                    <Modal.Title>Network Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>Network Error - Please check internet connection</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={()=>handleHome()}>Ok</Button>
                </Modal.Footer>
                </Modal>
            }
            {errorAlert!=="Error"?<></>:
                <Modal centered backdrop="static" show="true" onHide={callback}>
                <Modal.Header closeButton>
                    <Modal.Title>{msgtitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{msgbody}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={callback}>{msgbutton}</Button>
                </Modal.Footer>
                </Modal>
            }
        </>
    )
}

export function ShowAlertError2({errorAlert,setErrorAlert}) {
    const navigate = useNavigate();

    const handleLogout=() =>{
        setErrorAlert(null);
        localStorage.removeItem("token");
        setTimeout(() => {
            navigate('/', { replace: true });
        }, 100);
    }
        
    return (
        <>
            {errorAlert!=="Request failed with status code 403"?<></>:
                <Modal centered backdrop="static" show="true" onHide={handleLogout}>
                <Modal.Header closeButton>
                    <Modal.Title>Login Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>Login Expired. Please Login again</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleLogout}>Login</Button>
                </Modal.Footer>
                </Modal>
            }
        </>
    );
}
